<style>
    #wrapPrint {
        font-family: 'Helvetica Neue', Arial, sans-serif;
        background-color: #f4f4f4;
        margin: 0;
        padding: 0;
        color: #333;
    }


    .invoice-header {
        text-align: center;
        margin-bottom: 15px;
        border-bottom: 2px solid #53535f;
        padding-bottom: 8px;
    }

    .invoice-header h1 {
        font-size: 15px;
        margin: 0;
        color: #53535f;
        text-transform: uppercase;
    }

    .company-details, .client-details {
        margin-bottom: 10px;
    }

    .company-details p {
        margin: 5px 0;
        font-size: 10px;
        line-height: 1.2;
    }

    .client-details p {
        margin: 5px 0;
        font-size: 14px;
        line-height: 1.2;
    }

    .invoice-details {
        margin-bottom: 10px;
    }

    .invoice-details p {
        margin: 5px 0;
        font-size: 10px;
        line-height: 1.5;
    }

    .invoice-items {
        width: 100%;
        border-collapse: collapse;
        margin-bottom: 8px;
    }

    .invoice-items th, .invoice-items td {
        padding: 6px;
        border: 1px solid #53535f;
        text-align: left;
        font-size: 14px;
    }

    .invoice-items th {
        /*background-color: #53535f;*/
        color: #53535f;
        /*text-transform: uppercase;*/
        /*letter-spacing: 0.1em;*/
    }

    .invoice-items td {
        /*background-color: #f9f9f9;*/
    }

    .invoice-items tr:last-child td {
        /*border-bottom: none;*/
    }

    .invoice-totals {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 10px;
    }

    .invoice-totals table {
        width: 300px;
        border-collapse: collapse;
    }

    .invoice-totals th, .invoice-totals td {
        padding: 5px;
        font-size: 15px;
        text-align: left;
        border-top: 1px solid #e5e5e5;
    }

    .invoice-totals .grand-total {
        font-size: 15px;
        font-weight: bold;
        /*background-color: #f0f0f0;*/
        color: #333;
    }

    .invoice-footer {
        text-align: center;
        font-size: 10px;
        color: #999;
        margin-top: 6px;
        border-top: 1px solid #e5e5e5;
        padding-top: 6px;
    }

    .page-break {
        page-break-after: always;
    }
</style>
<div id="wrapPrint">
    <ng-container *ngFor="let invoice of data">
        <nz-card>
            <div class="invoice-header">
                <h1>Hóa Đơn</h1>
            </div>

            <div class="company-details">
                <p><strong>Hoa Tươi Ngày Mới</strong></p>
                <p><strong>Địa Chỉ:</strong> 264 Âu Cơ , Hồng Hà , Hà Nội</p>
                <p><strong>Số điện thoại:</strong> 0966724570</p>
            </div>

            <div class="client-details">
                <p><strong>Khách Hàng</strong></p>
                <p><strong>Tên khách hàng:</strong> {{ invoice.customerName }}</p>
                <p><strong>Địa Chỉ:</strong> {{ invoice.address }}</p>
                <p><strong>Số điện thoại:</strong> {{ invoice.phoneNumber }}</p>
                <p><strong>Ghi chú:</strong> {{ invoice.moreInfor }}</p>
            </div>

            <div class="invoice-details">
                <p><strong>Ngày:</strong> {{ invoice.createdDate |dateFormat }}</p>
            </div>

            <table class="invoice-items">
                <thead>
                <tr>
                    <th>Stt</th>
                    <th>Sản phẩm</th>
                    <th>Số Lượng</th>
                    <th>Đơn Giá</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let data of invoice.orderDetail; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>{{ data.productDetail }}</td>
                    <td>{{ data.quantity }}</td>
                    <td>{{ data.price  | number:'1.0-0' }}</td>
                </tr>
                </tbody>
            </table>

            <div class="invoice-totals">
                <table>
                    <tr>
                        <th>Tổng Cộng:</th>
                        <td>{{ invoice.amount  | number:'1.0-0' }}</td>
                    </tr>
                    <tr>
                        <th>Phí giao hàng:</th>
                        <td>{{ invoice.shipFee  | number:'1.0-0' }}</td>
                    </tr>
                    <tr class="grand-total">
                        <th>Thành Tiền:</th>
                        <td>{{ invoice.totalAmount  | number:'1.0-0' }}</td>
                    </tr>
                    <tr class="grand-total" *ngIf="invoice.channelPayment == 1">
                        <td colspan="2">KHÁCH CHUYỂN KHOẢN</td>
                    </tr>
                    <tr class="grand-total" *ngIf="invoice.channelPayment == 2 || invoice.channelPayment == 3">
                        <td colspan="2">THU TIỀN MẶT</td>
                    </tr>
                </table>
            </div>

            <div class="invoice-footer">
                Cảm ơn bạn đã ủng hộ shop mình nha!<br>
            </div>
        </nz-card>
        <!-- Add page break after each invoice -->
        <div class="page-break"></div>
    </ng-container>
</div>

<ng-template #editFooter>
    <div class="d-flex justify-content-end">
        <button nz-button nzType="primary" printSectionId="wrapPrint" [useExistingCss]="true" ngxPrint (click)="onPrint()">Print</button>
    </div>
</ng-template>
